import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import {filterProductPhotoImpl} from "./foreign.js";
const filterProductPhoto = x => Data$dNullable.nullable(
  filterProductPhotoImpl((() => {
    if (x.tag === "Nothing") { return Data$dNullable.null; }
    if (x.tag === "Just") { return Data$dNullable.notNull(x._1); }
    $runtime.fail();
  })()),
  Data$dMaybe.Nothing,
  Data$dMaybe.Just
);
export {filterProductPhoto};
export * from "./foreign.js";
